import React from 'react';
import './HealthcareFAQ.css';

import CurvedBottom from '../../../components/CurvedBottom/CurvedBottom';
import FlipCards from '../../../components/FlipCards/FlipCards';

const healthcareFAQ = ( props ) => {
	return (
		<section id="HealthcareFAQ" className="bg-color-1 hasCurve">
			<h2>Frequently <span>Asked</span> Questions</h2>
			<FlipCards cards={ props.cards } />
			<CurvedBottom />
		</section>
	);
};

export default healthcareFAQ;



// WEBPACK FOOTER //
// ./src/pages/Benefits/HealthcareFAQ/HealthcareFAQ.js